module.exports = __webpack_public_path__ + "static/media/izlozba (15).1a178abc.jpg";